package songwritersnotebook.app.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ExpandLess
import androidx.compose.material.icons.filled.ExpandMore
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import songwritersnotebook.app.data.Song
import songwritersnotebook.app.data.Section
import songwritersnotebook.app.data.Line

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun MoveRecordingSheet(
    song: Song,
    onDismiss: () -> Unit,
    onTargetSelected: (String) -> Unit
) {
    ModalBottomSheet(onDismissRequest = onDismiss) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(bottom = 16.dp)
        ) {
            Text(
                "Move Recording To...",
                style = MaterialTheme.typography.titleLarge,
                fontWeight = FontWeight.Bold,
                modifier = Modifier.padding(16.dp)
            )
            HorizontalDivider()
            LazyColumn(
                modifier = Modifier.fillMaxWidth().weight(1f, fill = false)
            ) {
                items(song.sections) { section ->
                    SectionTargetItem(section = section, onTargetSelected = onTargetSelected)
                }
            }
        }
    }
}

@Composable
fun SectionTargetItem(
    section: Section,
    onTargetSelected: (String) -> Unit
) {
    var isExpanded by remember { mutableStateOf(false) }

    Column(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clickable { isExpanded = !isExpanded }
                .padding(16.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = section.title.ifBlank { "Untitled Section" },
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold
            )
            Icon(
                imageVector = if (isExpanded) Icons.Default.ExpandLess else Icons.Default.ExpandMore,
                contentDescription = if (isExpanded) "Collapse" else "Expand"
            )
        }
        
        if (isExpanded) {
            // Option to assign to Section itself (Header)
            DropdownMenuItem(
                text = { Text("Attach to Section Header") },
                onClick = { onTargetSelected(section.id) },
                modifier = Modifier.background(MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.3f))
            )
            
            section.lines.forEachIndexed { index, line ->
                DropdownMenuItem(
                    text = { 
                        Text(
                            text = line.text.ifBlank { "Line ${index + 1} (Empty)" },
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        ) 
                    },
                    onClick = { onTargetSelected(line.id) },
                    modifier = Modifier.padding(start = 16.dp)
                )
            }
        }
        HorizontalDivider()
    }
}
